/**
 * Sort an array of objects by a specified key in ascending or descending order.
 *
 * @param {Array} array - The array of objects to sort.
 * @param {String} key - The key to sort by (e.g., "date", "name", "number").
 * @param {String} type - The type of data ("date", "string", or "number").
 * @param {String} order - The order to sort by ("asc" for ascending, "desc" for descending).
 * @returns {Array} - The sorted array.
 */
// export const sortArray = (array, key, type, order = "asc") => {
//     return array.sort((a, b) => {
//         const valA = a[key];
//         const valB = b[key];
//         let comparison = 0;

//         if (type === "number") {
//             comparison = valA - valB;
//         } else if (type === "date") {
//             comparison = new Date(valA) - new Date(valB);
//         } else if (type === "string") {
//             comparison = valA.localeCompare(valB);
//         } else {
//             throw new Error("Invalid type specified. Use 'number', 'date', or 'string'.");
//         }

//         // Reverse comparison for descending order
//         return order === "desc" ? -comparison : comparison;
//     });
// };

export const sortArray = (array, key, type, order = "asc") => {
    return array.sort((a, b) => {
        const valA = a[key] ?? ""; // Fallback for null/undefined
        const valB = b[key] ?? ""; // Fallback for null/undefined
        let comparison = 0;

        if (type === "number") {
            comparison = (valA || 0) - (valB || 0); // Ensure valid numbers
        } else if (type === "date") {
            comparison = new Date(valA).getTime() - new Date(valB).getTime(); // Ensure valid dates
        } else if (type === "string") {
            comparison = String(valA).localeCompare(String(valB)); // Convert to string
        } else {
            throw new Error("Invalid type specified. Use 'number', 'date', or 'string'.");
        }

        // Reverse comparison for descending order
        return order === "desc" ? -comparison : comparison;
    });
};
